export function fmt(n) {
  return 'Rs. ' + parseFloat(n || 0).toFixed(2);
}

export function fmtDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function fmtTime(d) {
  if (!d) return '';
  return new Date(d).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true });
}

export function fmtDateTime(d) {
  return `${fmtDate(d)} ${fmtTime(d)}`;
}

// Display label for a loose unit. Stored value stays terse ('l'); the UI shows
// the friendlier 'litre'.
export function unitLabel(unit) {
  if (!unit) return '';
  return unit === 'l' ? 'litre' : unit;
}

export function fmtQty(qty, unit) {
  if (!unit) return String(parseInt(parseFloat(qty) || 0));
  const n = parseFloat(qty) || 0;
  return `${parseFloat(n.toFixed(3))} ${unitLabel(unit)}`;
}

/**
 * Converts a rupee amount to words (Indian numbering: lakh/crore).
 * Mirrors the numWords() function from the original prototype.
 */
export function numWords(n) {
  const a = [
    '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
    'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
    'Eighteen', 'Nineteen',
  ];
  const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

  if (n === 0) return 'Zero';

  function w(x) {
    if (x < 20) return a[x];
    if (x < 100) return b[Math.floor(x / 10)] + (x % 10 ? ' ' + a[x % 10] : '');
    if (x < 1000) return a[Math.floor(x / 100)] + ' Hundred' + (x % 100 ? ' ' + w(x % 100) : '');
    if (x < 100000) return w(Math.floor(x / 1000)) + ' Thousand' + (x % 1000 ? ' ' + w(x % 1000) : '');
    if (x < 10000000) return w(Math.floor(x / 100000)) + ' Lakh' + (x % 100000 ? ' ' + w(x % 100000) : '');
    return w(Math.floor(x / 10000000)) + ' Crore' + (x % 10000000 ? ' ' + w(x % 10000000) : '');
  }

  const parts = String(parseFloat(n).toFixed(2)).split('.');
  const rupees = parseInt(parts[0], 10);
  const paise = parseInt(parts[1] || 0, 10);

  let res = w(rupees) + ' Rupees';
  if (paise > 0) res += ' and ' + w(paise) + ' Paise';
  return res + ' Only';
}

export const COMPANY = {
  name: 'Easy1Basket',
  address: 'Near Shyamakali Mandap, Ichhapur',
  city: 'Kendrapara - 754211',
  phone: '9090371171',
  email: 'Email: admin@easy1basket.in',
  gst: '',
  tagline: 'Smart Shopping, Every Day',
};
